import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { Colors } from '@shared/styles';

export function MBChatReadMarker() {
  return (
    <View row center padding={1}>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
      <View paddingHorizontal={1}>
        <MBText size="small" color={Colors.v2.red}>
          new messages
        </MBText>
      </View>
      <View flex>
        <MBSeparator color={Colors.v2.red} />
      </View>
    </View>
  );
}
